import { Icon } from "Components/atoms/Icon";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "shared/contexts/AuthContext";
import { useSearchContext } from "shared/contexts/SearchContext";
import { sendGTMEvent } from "shared/services/GTM";
import { buildAlertCreateUrl } from "shared/utils/alerts/alertPrefill";
import { getPlatformType } from "shared/utils/platform";
import { CtaButton, CtaWrapper, HelperText } from "./styles";

type AlertSerpCtaProps = {
  /** Indica se o layout atual é mobile */
  isMobile: boolean;
};

/**
 * CTA de sininho exibido na SERP. Leva ao formulário de criação de alerta
 * pré-preenchido com os dados da busca atual.
 */
const AlertSerpCta: React.FC<AlertSerpCtaProps> = ({ isMobile }) => {
  const { searchState } = useSearchContext();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const originCode = searchState.origin?.code ?? "";
  const destinationCode = searchState.destination?.code ?? "";

  if (!originCode || !destinationCode) return null;

  const handleClick = () => {
    const departureDates = searchState.departureDates ?? [];
    const returnDates = searchState.returnDates ?? [];

    sendGTMEvent("alertSerpCtaClick", {
      platform: getPlatformType(),
      isAuthenticated,
      IATA_origin: originCode,
      IATA_destination: destinationCode,
      IATA_route: `${originCode}-${destinationCode}`,
      tripType: searchState.tripType,
      departureDates,
      returnDates,
      adults: searchState.adults,
      children: searchState.children,
      babies: searchState.babies,
      isSearchFinished: searchState.isSearchFinished,
      minPrice:
        searchState.filteredFlightResults?.predefinedFilters?.priceFrom ?? null,
    });

    navigate(
      buildAlertCreateUrl({
        origin: originCode,
        destination: destinationCode,
        departureDates,
        returnDates: searchState.tripType === "roundTrip" ? returnDates : [],
        source: "serp",
      }),
    );
  };

  return (
    <CtaWrapper $isMobile={isMobile}>
      <CtaButton type="button" $isMobile={isMobile} onClick={handleClick}>
        <Icon svgName="bell-alert" size="medium" color="mediumBlue" />
        Criar alerta de preço
        {!isMobile && (
          <HelperText>Receba um aviso quando o preço baixar</HelperText>
        )}
      </CtaButton>
    </CtaWrapper>
  );
};

export default AlertSerpCta;
